import { FamilyFatherDetailAnscNotificationsCancellationsCrumbs } from 'cancellations/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsFatherDetailCivilStatusShared from 'shell/components/shared/ansc-notifications/research-family/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchFamilyNotificationsFatherDetailCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsFatherDetailCivilStatusShared
        items={FamilyFatherDetailAnscNotificationsCancellationsCrumbs()}
        scope={IdAmbito.Cancellazioni}
      />
    </Fragment>
  );
};

ResearchFamilyNotificationsFatherDetailCivilStatusPage.displayName =
  'Research Family Notifications CivilStatusPage component';

export default ResearchFamilyNotificationsFatherDetailCivilStatusPage;
